import React from "react";
import { Box, Typography, Divider, FormHelperText } from "@mui/material";
import Select from "react-select";
import { genderOptions, SkinOptions, tags, tagOptions } from "utility/data";

// Sample age options (1–100)
const ageOptions = Array.from({ length: 43 }, (_, i) => ({
  value: i + 18,
  label: `${i + 18}`,
}));

const TagSelection = ({ values, setFieldValue, touched, errors }) => {
  // Convert string array to select objects
  const toSelectValues = (array, options) =>
    (array || [])
      .map((val) => options.find((opt) => opt.value === val))
      .filter(Boolean);

  return (
    <>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" gutterBottom>
        Tags Selection
      </Typography>

      {/* Gender */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Gender
        </Typography>
        <Select
          isMulti
          name="suitableFor.gender"
          options={genderOptions}
          value={toSelectValues(values.suitableFor?.gender, genderOptions)}
          onChange={(selected) =>
            setFieldValue(
              "suitableFor.gender",
              selected.map((opt) => opt.value)
            )
          }
        />
        {touched.suitableFor?.gender && errors.suitableFor?.gender && (
          <FormHelperText error>{errors.suitableFor.gender}</FormHelperText>
        )}
      </Box>

      {/* Skin Types */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Select Skin Types
        </Typography>
        <Select
          isMulti
          name="skinTypes"
          options={SkinOptions}
          value={toSelectValues(values.skinTypes, SkinOptions)}
          onChange={(selected) =>
            setFieldValue(
              "skinTypes",
              selected.map((opt) => opt.value)
            )
          }
        />
        {touched.skinTypes && errors.skinTypes && (
          <FormHelperText error>{errors.skinTypes}</FormHelperText>
        )}
      </Box>

      {/* Concern Types */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Concern Types
        </Typography>
        <Select
          isMulti
          name="concerns"
          options={tagOptions}
          value={toSelectValues(values.concerns, tagOptions)}
          onChange={(selected) =>
            setFieldValue(
              "concerns",
              selected.map((opt) => opt.value)
            )
          }
        />
        {touched.concerns && errors.concerns && (
          <FormHelperText error>{errors.concerns}</FormHelperText>
        )}
      </Box>

      {/* Tags */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Select Tags
        </Typography>
        <Select
          isMulti
          name="tags"
          options={tags}
          value={toSelectValues(values.tags, tags)}
          onChange={(selected) =>
            setFieldValue(
              "tags",
              selected.map((opt) => opt.value)
            )
          }
        />
        {touched.tags && errors.tags && (
          <FormHelperText error>{errors.tags}</FormHelperText>
        )}
      </Box>

      {/* Min Age */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Minimum Age
        </Typography>
        <Select
          name="suitableFor.minAge"
          options={ageOptions}
          value={ageOptions.find(
            (opt) => opt.value === values.suitableFor?.minAge
          )}
          onChange={(selected) =>
            setFieldValue("suitableFor.minAge", selected?.value)
          }
        />
        {touched.suitableFor?.minAge && errors.suitableFor?.minAge && (
          <FormHelperText error>{errors.suitableFor.minAge}</FormHelperText>
        )}
      </Box>

      {/* Max Age */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Maximum Age
        </Typography>
        <Select
          name="suitableFor.maxAge"
          options={ageOptions}
          value={ageOptions.find(
            (opt) => opt.value === values.suitableFor?.maxAge
          )}
          onChange={(selected) =>
            setFieldValue("suitableFor.maxAge", selected?.value)
          }
        />
        {touched.suitableFor?.maxAge && errors.suitableFor?.maxAge && (
          <FormHelperText error>{errors.suitableFor.maxAge}</FormHelperText>
        )}
      </Box>
    </>
  );
};

export default TagSelection;
